import styled from '@emotion/styled'
import { theme } from 'j-comps'
import CanvaDropdown from '../../../../CanvaDropdown'
import config from '../../../../../../config'
import { connect } from 'react-redux'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.color[config.app].primary};
  height: calc(100% - 25px);
  min-height: 200px;
  margin: 10px;
  border: 2px dashed lightgrey;
`

const CanvaButtonContainer = styled.div`
  font-size: ${theme.font.size.xLarge};
`

const HelpContainer = styled.div`
  margin: ${theme.spacing.medium};
  text-align: left;
`

const HelpTitle = styled.p`
  font-weight: ${theme.font.weight.bold};
`

const HelpText = styled.p`
  color: grey;
`

const CreateNew = ({ source }) => {
  return (
    <Container>
      <div>
        {source === 'stream' && (
          <div>
            <HelpTitle>Ready to Create or Edit?</HelpTitle>
            <HelpContainer>
              <HelpText>
                Access Canva for Hootsuite directly from Content Sources.
              </HelpText>
              <HelpText>
                Get started by clicking the link below⁠, you will find the Canva
                app in the menu on the left hand side.
              </HelpText>
            </HelpContainer>
          </div>
        )}
        <CanvaButtonContainer>
          <CanvaDropdown linkText={'Content Sources'} />
        </CanvaButtonContainer>
      </div>
    </Container>
  )
}

const mapStateToProps = (state) => ({
  source: state.source,
})

export default connect(mapStateToProps)(CreateNew)
